import React from 'react';
import {Banner} from '@albert-io/atomic';
import classnames from 'classnames';

import './translation-header.scss';

interface BannerProps {
  [key: string]: any;
}
interface WarningHeaderProps extends BannerProps {
  text?: string;
  children?: any;
  supplement?: boolean;
}
const NoTranslationWarningHeader = ({
  text = 'No translations available',
  children,
  supplement,
  ...bannerProps
}: WarningHeaderProps) => {
  const Wrapper = children ? WrapperComponent : React.Fragment;
  return (
    <Wrapper supplement={supplement}>
      <Banner type='warning' {...bannerProps} border={!children}>
        {supplement && <Banner.Icon icon={['fal', 'language']} />}
        {text}
      </Banner>
      {children}
    </Wrapper>
  );
};

export default NoTranslationWarningHeader;

interface WrapperComponentsProps {
  children: any;
  supplement?: boolean;
}

const WrapperComponent = ({children, supplement = false}: WrapperComponentsProps) => {
  return (
    <div
      className={classnames('translation-header__wrapper', {
        'translation-header__wrapper--supplement': supplement
      })}
    >
      {children}
    </div>
  );
};
